import React from 'react';
import { CheckCircle, Award, BookOpen } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const AboutSection = ({ t }) => (
  <section id="about" className="py-16 bg-gray-50">
    <div className="container mx-auto px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-gray-900" style={{ fontFamily: 'Crimson Text, serif' }}>{t.about_title}</h2>
        <p className="text-center text-gray-600 mb-12">{t.about_welcome}</p>
        
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <Card>
            <CardContent className="pt-6">
              <h3 className="text-xl font-bold mb-4 text-gray-900">{t.about_intro_title}</h3>
              <p className="text-gray-700 leading-relaxed">{t.about_intro}</p>
            </CardContent>
          </Card>

          <div className="space-y-6">
            <Card>
              <CardContent className="pt-6">
                <h3 className="text-xl font-bold mb-3 text-gray-900">{t.about_qualification_title}</h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-amber-600 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700">M.A. LL.B.</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-amber-600 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700">LL.M.</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-amber-600 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700">Bar Council Enrollment: UP03008</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-amber-600 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700">COP No. 286647</span>
                  </li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6">
                <h3 className="text-xl font-bold mb-3 text-gray-900">{t.about_affiliation_title}</h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-amber-600 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700">Bar Association, Aligarh</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-amber-600 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700">High Court Bar Association, Allahabad</span>
                  </li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <Card className="bg-gradient-to-br from-blue-900 to-blue-800 text-white">
            <CardContent className="pt-6">
              <Award className="h-10 w-10 text-amber-400 mb-4" />
              <h3 className="text-2xl font-bold mb-3">{t.mission_title}</h3>
              <p className="leading-relaxed">{t.mission_text}</p>
            </CardContent>
          </Card>
          <Card className="bg-gradient-to-br from-amber-600 to-amber-700 text-white">
            <CardContent className="pt-6">
              <BookOpen className="h-10 w-10 text-white mb-4" />
              <h3 className="text-2xl font-bold mb-3">{t.vision_title}</h3>
              <p className="leading-relaxed">{t.vision_text}</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
